import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KeyCodeWithModifiersClass;
function KeyCodeWithModifiers() {
  if (KeyCodeWithModifiersClass === VOID) {
    class $ {
      constructor(code, alt, ctrl, shift, meta) {
        alt = alt === VOID ? false : alt;
        ctrl = ctrl === VOID ? false : ctrl;
        shift = shift === VOID ? false : shift;
        meta = meta === VOID ? false : meta;
        this.ocy_1 = code;
        this.pcy_1 = alt;
        this.qcy_1 = ctrl;
        this.rcy_1 = shift;
        this.scy_1 = meta;
      }
      toString() {
        return 'KeyCodeWithModifiers(code=' + this.ocy_1 + ', alt=' + this.pcy_1 + ', ctrl=' + this.qcy_1 + ', shift=' + this.rcy_1 + ', meta=' + this.scy_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.ocy_1);
        result = imul(result, 31) + getBooleanHashCode(this.pcy_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.qcy_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.rcy_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.scy_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KeyCodeWithModifiers()))
          return false;
        if (!(this.ocy_1 === other.ocy_1))
          return false;
        if (!(this.pcy_1 === other.pcy_1))
          return false;
        if (!(this.qcy_1 === other.qcy_1))
          return false;
        if (!(this.rcy_1 === other.rcy_1))
          return false;
        if (!(this.scy_1 === other.scy_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'KeyCodeWithModifiers');
    KeyCodeWithModifiersClass = $;
  }
  return KeyCodeWithModifiersClass;
}
//region block: exports
export {
  KeyCodeWithModifiers as KeyCodeWithModifiersyrb06kjwhumy,
};
//endregion

//# sourceMappingURL=KeyCode.mjs.map
